import { Button, Checkbox, FormControl, Grid, InputLabel, MenuItem, NativeSelect, Select, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import InfluencerTemplate from '../../../assets/Clients/Boticario/Influenciadores-template.xlsx';
import { useInputStyles } from '../../../shared/components/UploadStyles';
import { BasicDropzone } from '../../../shared/components/BasicDropzone';
import { InfluencerUploadInput } from './InfluencerUploadInput';
import { InfluencerUploadResult } from './InfluencerUploadResult';
import { AuthContext } from '../../Authentication/AuthContext';
import { HomeContext } from '../../Home/HomeContext';
import { StatusUpload } from '../../../shared/enum/StatusUpload';
import { InfluencerUploadResultInitial, InfluencerUploadResultModel } from '../../../Models/InfluencerUploadResultModel';
import { PageLocation } from '../../../shared/enum/PageLocation';
import { UploadLoading } from '../../../shared/components/UploadLoading';
import InfluencerSpreadsheetService from '../../../Services/InfluencerService';
import { AxiosResponse } from 'axios';
import { StatusResult } from '../../../shared/enum/StatusResult';
import { IErrorResponse } from '../../../shared/ErrorResponse';
import { ErrorHelper } from '../../../shared/ErrorHelper';
import InfluencerSubmitInput from '../components/InfluencerSubmitInput';
import { InfluencerSubmitResult } from '../components/InfluencerSubmitResult';

export default function InfluencerSubmit() {
    const classes = useInputStyles();
    const [selectedSubmitOption, setSelectedSubmitOption] = useState('');
    const authContext = React.useContext(AuthContext);
    const homeContext = React.useContext(HomeContext);
    const clientEnable = homeContext.influencerClientEnable;
    const [file, setFile] = React.useState<File | null>(null);
    const [status, setStatus] = React.useState<StatusUpload>(StatusUpload.INPUT);
    const [resultUpload, setResultUpload] = React.useState<InfluencerUploadResultModel>(InfluencerUploadResultInitial);

    async function uploadSpreadsheet(file: File) {
        if (!selectedSubmitOption) {
            homeContext.showError('Por favor, selecione uma opção de Submissão.<br/>');
            return;
        }
        setFile(file);

        const formData = new FormData();
        const clientId = clientEnable?.id_cliente;
        formData.append('documentData', JSON.stringify({ clientId: clientId, selectedSubmitOption: selectedSubmitOption }));//ajustar clinet id 
        formData.append('file', file);

        setStatus(StatusUpload.LOADING);
        setResultUpload(InfluencerUploadResultInitial);
        if (clientId) {
            InfluencerSpreadsheetService
                .postSpreadsheetFileInfluencerICE(authContext.login.user.id, formData)
                .then((res: AxiosResponse) => {
                    setResultUpload({ ...res.data.object, status: StatusResult.SUCCESS });
                    setStatus(StatusUpload.FINISH);
                }).catch((error) => {
                    if (!error.data || error.data.status == 500) {
                        setResultUpload({ ...InfluencerUploadResultInitial, message: error.toString(), title: 'Exibir detalhes do problema', property: 'Repository', status: StatusResult.ERROR });
                        setStatus(StatusUpload.FINISH);
                    } else {
                        const errorResponse: IErrorResponse = ErrorHelper(error);
                        setResultUpload({ ...InfluencerUploadResultInitial, message: errorResponse.message, title: 'Exibir detalhes do problema', property: error.data.errors[0].property, status: StatusResult.ERROR });
                        setStatus(StatusUpload.FINISH);
                    }
                });
        }

    }

    return (
        <>
            {status === StatusUpload.INPUT && (
                <InfluencerSubmitInput
                    selectedSubmitOption={selectedSubmitOption}
                    setSelectedSubmitOption={setSelectedSubmitOption}
                    uploadSpreadsheet={(file: File) => uploadSpreadsheet(file)} />)}
            {status === StatusUpload.LOADING && (
                <UploadLoading nameFile={file?.name ?? ''} />)}
            {status === StatusUpload.FINISH && (
                <InfluencerSubmitResult
                    nameFile={file?.name ?? ''}
                    result={resultUpload}
                    onClickNewSubmit={() => { setStatus(StatusUpload.INPUT); }} />)}
        </>
    );
}